import React from "react";
import "./ElementAnswers.scss";
import { DNAElementValue } from "../../DNA/DNA";
import { DNAElement } from "../../DNA/DNAElement/DNAElement";
import { clone } from "lodash";
import { Button } from "../../../Button/Button";

interface IProps {
    answers: DNAElementValue[]
    setAnswers?: (value: DNAElementValue[]) => void;
}

export function ElementAnswers({ answers, setAnswers }: IProps) {
    const editMode = !!setAnswers;

    const handleChange = (index: number) => {
        if (!setAnswers) return undefined;
        return (value: DNAElementValue) => {
            const newAnswers = clone(answers);
            newAnswers[index] = value;
            setAnswers(newAnswers);
        }
    }
    const addOption = () => {
        if (!setAnswers) return undefined;
        const newAnswers = clone(answers);
        newAnswers.push([0, 0, 0, 0]);
        setAnswers(newAnswers);
    }
    const removeOption = () => {
        if (!setAnswers) return undefined;
        const newAnswers = clone(answers);
        newAnswers.pop();
        setAnswers(newAnswers);
    }

    return (
        <div className="element-answers-wrapper">
            {answers.map((answer, index) => {
                return <DNAElement value={answer} key={index} onChange={handleChange(index)} />
            })}
            {editMode ? <div className="buttons-wrapper">
                <Button variant={'secondary'} onClick={addOption}>Add</Button>
                <Button variant={'secondary'} disabled={answers.length === 0} onClick={removeOption}>Remove</Button>
            </div> : undefined}
        </div>
    )
}
